import type { DeepPartial } from '@luna/utils-ts';
import type { RoundingSavingsConfig } from '@shared/products-feature-configs';

export const roundingSavings: DeepPartial<RoundingSavingsConfig> = {
    enabled: true,
    showSFondsPlan: true,
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    turboSavingOptions: [0, 1, 2, 3, 4, 5, 10, 15],
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    simulationMonthOptions: [1, 3, 6, 12],
    savingGoals: [
        'DINNER',
        'CAR',
        'BICYCLE',
        'TV',
        'SAVING_FOR_GRANDCHILDREN',
        'SAVING_FOR_RAINY_DAY',
        'MOBILE_PHONE',
        'CONCERT',
        'BIKE',
        'PC',
        'SUMMER_HOLIDAYS',
        'SHOPPING_TRIP',
        'TABLET_PC',
        'FINANCIAL_FORSIGHT',
        'WINTER_HOLIDAYS',
    ],
    sFondsGoals: ['SAVING_FOR_MY_S_FUNDS_PLAN'],
};
